import React from 'react';

export function UniBielefeld(props) {
  const style={alignSelf:'start', margin:'0 5px'};
  return (
    <div style={style}>
      Universität Würzburg & Universität Bielefeld<br/>
      (in Kooperation mit der FernUniversität in Hagen <br/>
      und der Universität Freiburg)<br/>
      Dr. Veit Kubik
    </div>
  );
}
